const printService = {
    print: function (target) {
        if (!target) {
            return;
        }

        let printTarget;

        if (target.constructor === String) {
            printTarget = document.getElementById(target)
        } else if (typeof target === 'object' && 'outerHTML' in target) {
            printTarget = target;
        }

        if (!printTarget) {
            return;
        }

        const printContainer  = document.createElement('div');

        printContainer.innerHTML = printTarget.outerHTML;
        printContainer.classList.add('printArea');
        document.body.appendChild(printContainer);
        window.addEventListener('afterprint', () => { printContainer.remove(); });
        window.print();
    }
};
export default printService;